import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-close",
  "use": "spr-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"spr-close\"><defs><path fill=\"currentColor\" id=\"spr-close_a\" d=\"M1005 152c-.25 0-.5-.1-.7-.3a1 1 0 0 1 0-1.4l6.23-6.26-6.22-6.26a1 1 0 0 1 0-1.4.99.99 0 0 1 1.4 0l6.22 6.25 6.23-6.26a.98.98 0 0 1 1.4 0 1 1 0 0 1 0 1.41l-6.23 6.26 6.22 6.26a1 1 0 0 1-.7 1.7c-.25 0-.5-.1-.7-.3l-6.22-6.26-6.22 6.26c-.2.2-.45.3-.7.3z\" /></defs><use xlink:href=\"#spr-close_a\" transform=\"translate(-1004 -136)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/close.svg
// module id = 249
// module chunks = 0